import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { DefaultProjectorFn } from '@ngrx/store/src/selector';

import { ToastState } from '../shared-state.interface';
import { toastAdapter } from './toast.reducer';

export const getToastState: MemoizedSelector<
    object,
    ToastState,
    DefaultProjectorFn<ToastState>
> = createFeatureSelector<ToastState>('toast');

export const { selectIds, selectEntities, selectTotal } = toastAdapter.getSelectors(getToastState);
export const selectAllToasts = toastAdapter.getSelectors(getToastState).selectAll;
